module.exports = __webpack_public_path__ + "img/right-icon.be5dc792.png";